import React, { forwardRef, useMemo } from 'react';
import classNames from 'classnames';
import { ButtonSize, ButtonVariant } from 'components/UI_kit_3/Button/Button';
import styles from './Button.module.scss';

export interface ILinkButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: ButtonVariant;
  size?: ButtonSize
  disabled?: boolean;
  prefixIcon?: React.ReactNode;
}

const LinkButton = forwardRef<HTMLAnchorElement, ILinkButtonProps>(({
  children,
  variant = 'link',
  className,
  size = 'md',
  disabled,
  prefixIcon,
  ...props
}, ref) => {
  const variantClass = useMemo<string>(() => styles[`btn-${variant}`], [variant]);

  const sizeClass = useMemo<string>(() => styles[`btn-${size}`], [size]);

  return (
    <a
      ref={ref}
      className={classNames(className, styles.btn, variantClass, sizeClass, {
        [styles.disabled]: disabled,
      })}
      {...props}
      target="_blank"
    >
      {prefixIcon}
      {children && <span>{children}</span>}
    </a>
  );
});
export default LinkButton;
